import React from "react";
import { Monitor, Smartphone, Tablet } from "lucide-react";

interface LoginHistorySkeletonProps {
  count?: number;
}

const getDeviceIcon = (type: string, isActive: boolean = false) => {
  const iconClass = isActive
    ? "w-5 h-5 text-green-600 dark:text-green-400 opacity-50"
    : "w-5 h-5 text-text-secondary dark:text-text-secondary opacity-50";

  switch (type.toLowerCase()) {
    case "desktop":
      return <Monitor className={iconClass} />;
    case "mobile":
      return <Smartphone className={iconClass} />;
    case "tablet":
      return <Tablet className={iconClass} />;
    default:
      return <Monitor className={iconClass} />;
  }
};

export const LoginHistorySkeleton: React.FC<LoginHistorySkeletonProps> = ({
  count = 5,
}) => {
  const deviceTypes = ["desktop", "mobile", "tablet"];

  return (
    <div className="h-full max-h-[400px] overflow-y-auto border border-border-secondary dark:border-border-secondary rounded-lg">
      {Array.from({ length: count }, (_, index) => {
        const deviceType = deviceTypes[index % deviceTypes.length];
        const isLast = index === count - 1;
        const isActive = index === 0; // İlk eleman active

        return (
          <div
            key={index}
            className={`flex items-center gap-4 p-4 ${
              isActive
                ? "bg-green-50 dark:bg-green-900/20 border-l-4 border-l-green-500 dark:border-l-green-400"
                : ""
            } ${
              !isLast
                ? "border-b border-border-secondary dark:border-border-secondary"
                : ""
            }`}
          >
            {/* Device Icon */}
            <div className="flex-shrink-0">
              {getDeviceIcon(deviceType, isActive)}
            </div>

            {/* Device Info Skeleton */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                {/* Device Name Skeleton */}
                <div className="animate-pulse">
                  <div
                    className="h-4 bg-muted rounded"
                    style={{ width: `${120 + Math.random() * 80}px` }}
                  />
                </div>

                {/* Active Badge Skeleton (only for first item) */}
                {isActive && (
                  <div className="animate-pulse">
                    <div className="h-5 w-20 bg-green-100 dark:bg-green-900 rounded-full" />
                  </div>
                )}
              </div>

              {/* Location & Time Skeleton */}
              <div className="animate-pulse">
                <div
                  className="h-3 bg-muted/60 rounded mb-1"
                  style={{ width: `${180 + Math.random() * 60}px` }}
                />
                {/* IP Address Skeleton */}
                <div
                  className="h-3 bg-muted/40 rounded"
                  style={{ width: `${100 + Math.random() * 40}px` }}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
